import { FunctionComponent } from "react"
import { QueryStatus } from "react-query"
import { css, cx } from "@emotion/css"
import CircularProgress from "@material-ui/core/CircularProgress"
import { CircularProgressProps } from "@material-ui/core/CircularProgress/CircularProgress"

export const CircularProgressOverlay: FunctionComponent<{
  status?: QueryStatus
  className?: string
  circularProgressProps?: CircularProgressProps
}> = ({ children, status, className, circularProgressProps }) => {
  const size = circularProgressProps?.size || 50
  const style = {
    fieldWithLoader: css`
      position: relative;

      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.75);
        z-index: 1;
        opacity: 0;
        visibility: hidden;
      }

      @keyframes show {
        100% {
          opacity: 1;
          visibility: visible;
        }
      }
    `,
    animateBackdrop: css`
      ::after {
        animation: show 600ms 100ms cubic-bezier(0.38, 0.97, 0.56, 0.76)
          forwards;
      }
    `,
    loader: css`
      position: absolute;
      z-index: 2;
      top: calc(50% - ${Number(size) / 2}px);
      left: calc(50% - ${Number(size) / 2}px);
    `,
    error: css`
      position: absolute;
      z-index: 2;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: red;
    `,
  }

  return (
    <div
      className={cx(style.fieldWithLoader, className, {
        [style.animateBackdrop]: status === "loading" || status === "error",
      })}
    >
      {children}
      {status === "loading" && (
        <CircularProgress
          size={size}
          {...circularProgressProps}
          className={style.loader}
        />
      )}
      {status === "error" && <span className={style.error}>Error!</span>}
    </div>
  )
}
